import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { OrderHeadGet } from '@app/services/orderhead.service';
import { OrderHeadCustomerFormGroup } from '../../order-head-edit/order-head-edit.component';
import { CustomerPersonItem } from '@app/services/economy.service';

@Component({
    selector: 'tt-order-head-customer-form',
    templateUrl: './order-head-customer-form.component.html',
    styleUrls: ['./order-head-customer-form.component.css'],
})
export class OrderHeadCustomerFormComponent {
    @Input()
    public get?: OrderHeadGet;

    @Input()
    public form?: FormGroup<OrderHeadCustomerFormGroup>;

    @Input()
    public customerPersons: CustomerPersonItem[] = [];
}
